<template>
    <div class="xes-handout-list" :class="selectType">
        <el-table :data="list" border style="width: 100%" fit @selection-change="selectionChange" ref="table">
            <el-table-column type="selection" width="40"> </el-table-column>
            <el-table-column resizable v-for="item in headers" :key="item.prop" :prop="item.prop" :label="item.name" align="center"> </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    props: ['list', 'selectType', 'tableOption'],
    data() {
        return {
            ths: [
                { prop: 'id', name: 'ID' },
                { prop: 'name', name: '讲义名称' },
                { prop: 'year_name', name: '学年' },
                { prop: 'term_name', name: '学期' },
                { prop: 'grade_name', name: '年级' },
                { prop: 'version_name', name: '版本' },
                { prop: 'create_real_name', name: '创建人' },
                { prop: 'create_time', name: '创建时间' },
                { prop: 'modify_real_name', name: '修改人' },
                { prop: 'modify_time', name: '修改时间' },
                { prop: 'plan_name', name: '讲次' },
                { prop: 'area_name', name: '地区' },
                { prop: 'status_name', name: '状态' },
                { prop: 'freeze_name', name: '冻结状态' }
            ]
        }
    },
    computed: {
        headers() {
            let arr = []
            this.ths.forEach(el => {
                if (this.tableOption[el.prop]) {
                    arr.push(el)
                }
            })
            return arr
        }
    },
    methods: {
        selectionChange(selection, raw) {
            if (this.selectType == 'radio') {
                let item = selection.splice(0, selection.length - 1)
                item.forEach(el => {
                    this.$refs.table.toggleRowSelection(el, false)
                })
                this.$emit('selection', selection)
            } else {
                this.$emit('selection', selection)
            }
        }
    }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// packages/handout-filter/src/list.vue